export default __webpack_public_path__ + "static/heroSectionImg-2b7a9c68dbb2b07453364eafb3dbd6fa.webp";